import React from 'react';
import { useIntl } from 'react-intl';
import { Modal } from '../../../_shared/Modal/Modal';
import { useSimpleDragToClose } from '@/hooks';
import styles from './AboutThisEventModal.module.scss';

export type AboutThisEventModalProps = {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const AboutThisEventModal: React.FC<AboutThisEventModalProps> = React.memo(({ visible, onClose, children }) => {
  const { formatMessage } = useIntl();

  useSimpleDragToClose({
    onClose,
  });

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      __containerClassName={styles.modalContainer}
      title={formatMessage({ id: 'Overview' })}
    >
      <div className={styles.modulesWrapper}>{children}</div>
    </Modal>
  );
});

AboutThisEventModal.displayName = 'AboutThisEventModal';
